'use strict'

export default class ListController {

  /*@ngInject*/
  constructor ($http, $stateParams, $state) {
    this.$http = $http
    this.$stateParams = $stateParams
    this.$state = $state

    this.page = 1
    this.params = {
      offset: this.page - 1,
      limit: 100,
      sortBy: 'createdAt',
      order: -1
    }
  }

  $onInit () {
    if (this.$stateParams.page) {
      this.page = this.$stateParams.page
    }
    this.getDevices()
  }

  getDevices () {
    this.params.offset = (this.page - 1) * this.params.limit
    this.$http.get('/api/devices', {params: this.params}).then(res => {
      this.devices = res.data.data
    })
  }

  delete (id) {
    if (confirm('确定？')) {
      this.$http.delete(`/api/devices/${id}`).then(res => {
        this.getDevices()
      })
    }
  }

  pageChanged () {
    this.$state.go('devices.list', {page: this.page})
  }

  search (text) {
    this.$http.get(`/api/devices/search?search=${text}`).then(res => {
      this.devices = res.data.data
    })
  }

}



// WEBPACK FOOTER //
// ./client/app/devices/list/list.controller.js